// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__1N-yY"};